import type { SettingsCategory } from './types'

interface SancareSettingsData {
  interface: SettingsCategory
  automation: SettingsCategory
  dialysis: SettingsCategory
  import: SettingsCategory
}

const sancareSettingsData: SancareSettingsData = {
  interface: {
    label: 'settings.sancareSettings.categories.interface',
    settings: [
      {
        name: 'enable_smr',
        label: 'settings.sancareSettings.settings.enable_smr',
        type: 'bool',
      },
      {
        name: 'enable_pseudonymization',
        label: 'settings.sancareSettings.settings.enable_pseudonymization',
        type: 'bool',
      },
      {
        name: 'enable_data_downgrading',
        label: 'settings.sancareSettings.settings.enable_data_downgrading',
        type: 'bool',
      },
      {
        name: 'enable_manual_acts_external_export',
        label: 'settings.sancareSettings.settings.enable_manual_acts_external_export',
        type: 'bool',
      },
      {
        name: 'enable_comments_external_export',
        label: 'settings.sancareSettings.settings.enable_comments_external_export',
        type: 'bool',
      },
      {
        name: 'hide_sancare_searches_details',
        label: 'settings.sancareSettings.settings.hide_sancare_searches_details',
        type: 'bool',
      },
      {
        name: 'enable_ai_suggestions',
        label: 'settings.sancareSettings.settings.enable_ai_suggestions',
        type: 'bool',
      }
    ],
  },
  automation: {
    label: 'settings.sancareSettings.categories.automation',
    settings: [
      {
        name: 'demo_mode',
        label: 'settings.sancareSettings.settings.demo_mode',
        type: 'bool',
      },
      {
        name: 'session_automation',
        label: 'settings.sancareSettings.settings.session_automation',
        type: 'bool',
      },
      {
        name: 'non_session_automation',
        label: 'settings.sancareSettings.settings.non_session_automation',
        type: 'bool',
      },
      {
        name: 'rules_automation',
        label: 'settings.sancareSettings.settings.rules_automation',
        type: 'bool',
      },
      {
        name: 'renewal_automation',
        label: 'settings.sancareSettings.settings.renewal_automation',
        type: 'bool'
      }
    ],
  },
  dialysis: {
    label: 'settings.sancareSettings.categories.dialysis',
    settings: [
      {
        name: 'enable_dialyse',
        label: 'settings.sancareSettings.settings.enable_dialyse',
        type: 'bool',
      },
      {
        name: 'dialysis_medical_units',
        label: 'settings.sancareSettings.settings.dialysis_medical_units',
        type: 'medicalUnit',
      }
    ]
  },
  import: {
    label: 'settings.sancareSettings.categories.import',
    settings: [
      {
        name: 'enable_ml_negation_detection',
        label: 'settings.sancareSettings.settings.enable_ml_negation_detection',
        type: 'bool',
      },
      {
        name: 'restricted_legal_finess',
        label: 'settings.sancareSettings.settings.restricted_legal_finess',
        type: 'finess',
      },
      {
        name: 'restricted_geo_finess',
        label: 'settings.sancareSettings.settings.restricted_geo_finess',
        type: 'finess',
      }
    ]
  }
}
export default sancareSettingsData
